import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/**
 * An error that was thrown during the process of making a request.
 */
export var RequestError =
/*#__PURE__*/
function (_Error) {
  _inherits(RequestError, _Error);

  function RequestError(message, code, status) {
    var _this;

    _classCallCheck(this, RequestError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RequestError).call(this, message));
    _this.name = 'RequestError';
    _this.message = message;
    _this.code = code;
    _this.status = status || 0;
    return _this;
  }

  return RequestError;
}(_wrapNativeSuper(Error));